import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGender } from "src/models/General/Gender.models";

interface GenderState {
  genders: IGender[];
  genderToEdit: IGender | null;
}

const initialState: GenderState = {
  genders: [],
  genderToEdit: null,
};

const genderSlice = createSlice({
  name: "Gender",
  initialState,
  reducers: {
    setGenderList: (state, action: PayloadAction<IGender[]>) => {
      state.genders = action.payload;
    },
    concatListGender: (
      state: GenderState,
      action: PayloadAction<IGender[]>
    ) => {
      state.genders = [...state.genders.concat(action.payload)];
    },
    setGenderToEdit: (state, action: PayloadAction<IGender | null>) => {
      state.genderToEdit = action.payload;
    },
    addGender: (state, action: PayloadAction<IGender>) => {
      state.genders.push(action.payload);
    },
    updateGender: (state, action: PayloadAction<IGender>) => {
      let itemIndex = state.genders.findIndex(
        item => item.genderId === action.payload.genderId
      );
      if (itemIndex !== -1) state.genders[itemIndex] = action.payload;
    },
    deleteGender: (state, action: PayloadAction<number>) => {
      const newArray = state.genders.filter(
        item => item.genderId !== action.payload
      );
      state.genders = newArray;
    },
  },
});

export const {
  setGenderList,
  concatListGender,
  setGenderToEdit,
  addGender,
  updateGender,
  deleteGender,
} = genderSlice.actions;

export default genderSlice.reducer;
